
		<ansyn-app [version]="version"></ansyn-app>
	